.dimensionInput {
  flex-grow: 1;
  min-width: 3.75rem;
}
.weightInput {
  flex-grow: 1;
  min-width: 4rem;
}
